import { Checkbox, Divider, Menu, Radio, Stack, Text } from '@mantine/core'

import { Toolbar } from '#components/Toolbar'

import { useDiffAlgorithm } from '../useDiffAlgorithm'

interface AsteriskToolbarMenuProps {
  isStaff: boolean
  revisionMarkPlacement: 'left' | 'right'
  highlightAdditions: boolean
  showDeletions: boolean
  onRevisionMarkPlacementChange: (placement: 'left' | 'right') => void
  onHighlightAdditionsChange: (highlight: boolean) => void
  onShowDeletionsChange: (show: boolean) => void
}

export const AsteriskToolbarMenu = (props: AsteriskToolbarMenuProps) => {
  'use memo'

  const diff = useDiffAlgorithm()

  return (
    <Menu position="bottom-end">
      <Menu.Target>
        <Toolbar.Button dropdown icon="fa-sliders" label="Settings" />
      </Menu.Target>
      <Menu.Dropdown>
        <Stack px={10} py={10}>
          <Stack gap="sm">
            <Text fz="sm" fw="bold">
              Revision mark placement
            </Text>
            <Radio
              label="Left margin"
              checked={props.revisionMarkPlacement === 'left'}
              onChange={() => props.onRevisionMarkPlacementChange('left')}
              style={{ userSelect: 'none' }}
            />
            <Radio
              label="Right margin"
              checked={props.revisionMarkPlacement === 'right'}
              onChange={() => props.onRevisionMarkPlacementChange('right')}
              style={{ userSelect: 'none' }}
            />
          </Stack>
          <Divider />
          <Checkbox
            checked={props.highlightAdditions}
            label="Highlight additions in green"
            onChange={(v) =>
              props.onHighlightAdditionsChange(v.currentTarget.checked)
            }
            style={{ userSelect: 'none' }}
          />
          <Checkbox
            checked={props.showDeletions}
            label="Show deletions"
            onChange={(v) =>
              props.onShowDeletionsChange(v.currentTarget.checked)
            }
            style={{ userSelect: 'none' }}
          />
          {props.isStaff && (
            <>
              <Menu.Divider />
              <Menu.Label>Staff Only</Menu.Label>
              <Checkbox
                checked={diff.algorithm === 'changeset'}
                label="Diff using changeset"
                onChange={({ currentTarget: { checked } }) =>
                  diff.overrideWith(checked ? 'changeset' : 'legacy')
                }
              />
            </>
          )}
        </Stack>
      </Menu.Dropdown>
    </Menu>
  )
}
